import { Route } from 'react-router'
import { RoutesWithNotFound } from 'entities/ExportRouters/ui/RoutesWithNotFound'
import { AddNumberFromAppRoutes } from 'pages/settings/pages/numbers/pages/AddNumberFromApp/route/type'
import { AddNumberFromAppAccessLayout } from 'pages/settings/pages/numbers/pages/AddNumberFromApp/layout/AddNumberFromAppAccessLayout'
import { AddNumberFromAppStepsLayout } from 'pages/settings/pages/numbers/pages/AddNumberFromApp/layout/AddNumberFromAppStepsLayout'
import { SelectAppAndNumbers } from 'pages/settings/pages/numbers/pages/AddNumberFromApp/ui/SelectAppAndNumbers/SelectAppAndNumbers'
import { AssignNumber } from 'pages/settings/pages/numbers/pages/AddNumberFromApp/ui/AssignNumber/AssignNumber'
import { AddNumberFromAppProviderLayout } from 'pages/settings/pages/numbers/pages/AddNumberFromApp/layout/AddNumberFromAppProviderLayout'

export const AddNumberFromAppStepsRouter = () => {
  return (
    <RoutesWithNotFound>
      <Route element={<AddNumberFromAppAccessLayout />}>
        <Route element={<AddNumberFromAppProviderLayout />}>
          <Route path={AddNumberFromAppRoutes.steps} element={<AddNumberFromAppStepsLayout />}>
            <Route
              path={AddNumberFromAppRoutes.selectAppAndNumbers}
              element={<SelectAppAndNumbers />}
            />
            <Route path={AddNumberFromAppRoutes.assignNumber} element={<AssignNumber />} />
          </Route>
        </Route>
      </Route>
    </RoutesWithNotFound>
  )
}
